export default __webpack_public_path__ + "static/media/coned-icons.5a608f66.ttf";